<template>
  <div style="background: #ffcc33">
    <img alt="Vue logo" src="../assets/image/3-24011Q54F40-L.jpg" style="height:auto;width: 100%;">
  </div>
  <div style="display: flex;background: #ffcc33;padding: 0 10%;">
    <div style="flex: 1;margin: 2%;">
      <img alt="Vue logo" src="../assets/image/2-20042212502b28.jpg" style="height:auto;width: 100%;border-radius: 20px;">
    </div>
    <div style="flex: 1;margin: 2%;">
      <img alt="Vue logo" src="../assets/image/2-200422130615V2.jpg" style="height:auto;width: 100%;border-radius: 20px;">
    </div>
    <div style="flex: 1;margin: 2%;">
      <img alt="Vue logo" src="../assets/image/2-200422131032U1.jpg" style="height:auto;width: 100%;border-radius: 20px;">
    </div>
  </div>
  <div style="padding: 0 10%">
    <img alt="Vue logo" src="../assets/image/2-200FG03444Y9.jpg" style="height:auto;width: 100%;">
  </div>
  <div class="meishi_box">
    <div style="text-align: center;margin: 20px 0;">
      <div style="font-size: 30px;color: #fe8b00">美味鲜食</div>
      <div>DELICIOUS +</div>
    </div>
    <div style="margin: 10px">
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane v-for="(item,index) in lista" :label="item.name" :name="item.name" :key="index" style="line-height: 30px;color: #656464;padding:0 10%">
            <el-row :gutter="24">
              <el-col :lg="6"  :sm="6" :xs="12" v-for="(itemb,index) in item.list" :key="index" style="margin: 10px 0;text-align: center;" @click="lookDetails_btn(itemb)" >
                <div>
                  <img :src="itemb.img" style="width: 100%;height: 100%" />
                  <div style="text-align: center">{{itemb.name}}</div>
                </div>
              </el-col>
            </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
  <el-row :gutter="24" style="padding: 0;margin: 0">
    <el-col :xl="12" :lg="12" :md="12"  :sm="24" :xs="24" style="padding: 0" >
      <div style="margin: 8px">
        <div class="dynamic">
          <div style="width: 5px;margin-right: 3px;">
            <div style="flex: 1;height: 10px;background: #1b3500"></div>
            <div style="flex: 1;background: #ff4f00;height: 10px"></div>
          </div>
          公司动态<span>NEWS CENTER</span>
        </div>
        <div class="news_div"  v-for="(itemc,index) in list[0].list" :key="index" @click="NewsDetail(itemc,'listDongtai')" >
          <div><img src="../assets/image/threedian.png" style="width: 8px;transform: rotate(97deg);margin-right: 2px"/></div>
          <div style="flex: 1">
            <strong style="color: #656464" class="title_div_name">{{ itemc.title }}</strong>
          </div>
          <div style="color: #898989">{{ itemc.time }}</div>
        </div>
      </div>
    </el-col>
    <el-col  :xl="12"  :lg="12" :md="12" :sm="24" :xs="24" style="padding: 0" >
      <div style="margin: 8px">
        <div class="dynamic">
          <div style="width: 5px;margin-right: 3px;">
            <div style="flex: 1;height: 10px;background: #1b3500"></div>
            <div style="flex: 1;background: #ff4f00;height: 10px"></div>
          </div>
          汇米巴故事<span>BRAND STORY</span></div>
        <div class="news_div"  v-for="(itemc,index) in list[1].list" :key="index"  @click="NewsDetail(itemc,'listDongtai')">
          <div><img src="../assets/image/threedian.png" style="width: 8px;transform: rotate(97deg);margin-right: 2px"/></div>
          <div style="flex: 1">
            <strong style="color: #656464" class="title_div_name">{{ itemc.title }}</strong>
          </div>
          <div style="color: #898989">{{ itemc.time }}</div>
        </div>
      </div>
    </el-col>
  </el-row>
  <el-dialog
      v-model="dialogVisible"
      :title="titleName"
      width="300"
      :before-close="handleClose"
  >
    <div >
      <img :src="imgInfo.img" style="width: 100%;height: 100%"/>
      <div style="font-size: 30px;margin: 10px 0">{{imgInfo.name}}</div>
      <div>{{imgInfo.name}}</div>
    </div>
    <span>

    </span>
  </el-dialog>
</template>

<script>
import dataList  from "@/js/DataList";
export default {
  name: 'HelloWorld',
  // props: {
  //   msg: String
  // }
  data(){
    return{
      list:dataList.listDongtai,

      activeName:'营养便当',
      dialogVisible:false,
      titleName:'',
      imgInfo:[],
      lista : dataList.listmeishi,
      menuList:[{
        name:'首页',value:1
      },{
        name:'关于汇米巴',value:1
      },{
        name:'品牌动态',value:1
      },{
        name:'美味鲜食',value:1
      },{
        name:'便利生活',value:1
      },{
        name:'我要加盟',value:1
      },{
        name:'城聘英才',value:1
      },],
      meishiList:[
        {name:'营养便当',value:1},
        {name:'方便饭团',value:2},
        {name:'和风寿司',value:3},
        {name:'经典风味粉面',value:4},
        {name:'营养汤粥',value:5},
        {name:'美味卤菜',value:6},
        {name:'风味蛋类',value:7},
      ]
    }
  },methods:{
    lookDetails_btn(e){
      this.imgInfo=e
      this.titleName=e.name
      this.dialogVisible=true
    },
    handleClose(){
      this.dialogVisible=false
    },
    NewsDetail(e,name){
      console.log(e)
      console.log(name)
      this.$router.push({ path: '/news', query: { id: e.id,name:name,type:e.type}}) // 这样写是有效的
      // this.$router.push(`/news/${e.id}`) // 注意是反引号模板字符串
      // this.$router.push({ name: 'News', params: { id: e.id } }) // 假设 e.name 是参数值
    }
  },mounted() {
    console.log(this.list[0])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dynamic{
  display: flex;
  font-size: 26px;
  color: #FF5000;
  margin: 0px;
  padding: 10px 2px 2px 0;
  align-items: center;
}
.dynamic span{
  margin-left: 10px;
  text-indent: 8px;
  font-size: 12px;
  color: #7D7D7D;
  padding: 18px 0 0 0;
}
.text_nowrap{
  margin-top: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.news_div{
  display: flex;font-size: 14px;    border-bottom: 1px dashed #ccc;    line-height: 21px;
  padding: 10px 0px;
}
.xianwei_div{
  background: white;
  color: #76838f;
  margin: 5px;
  padding: 5px 15px;
  font-size: 14px;
}
.meishi_box{
  padding: 3% 0;
  background-image: url('../assets/image/1505973408.jpg');
  background-size: cover;
}
.el-menu--horizontal.el-menu {
  border-bottom:none;
}
:deep .el-tabs__content {
  height: 100%;
  overflow: visible;
}
:deep .el-tabs__item.is-active, .el-tabs__item:hover {
  color: #FF5000;
}
:deep .el-tabs__item.is-active, .el-tabs__item:hover {
  color: #FF5000 !important;
}

:deep  .el-tabs__active-bar {
  background-color:white;

}
:deep .el-tabs__nav {
  float: unset;
  justify-content: center;
  display: flex;
  background: white;
  overflow: auto;

}
.el-tabs__nav.is-top {
  background: white;

}
.el-tabs__content{
  height: 100%;
}
.title_div_name:hover{
  color: #FF5000 !important;
}
:deep .el-col, .el-row{
  padding-bottom: 0;
  padding-left: 0;
}
</style>
